/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';


export default class CornerDrag extends PureComponent {
  static propTypes = { className: PropTypes.string };

  static defaultProps = { className: undefined };

  render() {
    const { className, ...props } = this.props;

    return (
      <svg
        {...props}
        className={className}
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.5 19.2C7.32843 19.2 8 18.5284 8 17.7C8 16.8716 7.32843 16.2 6.5 16.2C5.67157 16.2 5 16.8716 5 17.7C5 18.5284 5.67157 19.2 6.5 19.2Z" />
        <path d="M12.1 19.2C12.9284 19.2 13.6 18.5284 13.6 17.7C13.6 16.8716 12.9284 16.2 12.1 16.2C11.2715 16.2 10.6 16.8716 10.6 17.7C10.6 18.5284 11.2715 19.2 12.1 19.2Z" />
        <path d="M12.1 13.6C12.9284 13.6 13.6 12.9284 13.6 12.1C13.6 11.2716 12.9284 10.6 12.1 10.6C11.2715 10.6 10.6 11.2716 10.6 12.1C10.6 12.9284 11.2715 13.6 12.1 13.6Z" />
        <path d="M17.7 8C18.5284 8 19.2 7.32843 19.2 6.5C19.2 5.67157 18.5284 5 17.7 5C16.8716 5 16.2 5.67157 16.2 6.5C16.2 7.32843 16.8716 8 17.7 8Z" />
        <path d="M17.7 19.2C18.5284 19.2 19.2 18.5284 19.2 17.7C19.2 16.8716 18.5284 16.2 17.7 16.2C16.8716 16.2 16.2 16.8716 16.2 17.7C16.2 18.5284 16.8716 19.2 17.7 19.2Z" />
        <path d="M17.7 13.6C18.5284 13.6 19.2 12.9284 19.2 12.1C19.2 11.2716 18.5284 10.6 17.7 10.6C16.8716 10.6 16.2 11.2716 16.2 12.1C16.2 12.9284 16.8716 13.6 17.7 13.6Z" />
      </svg>
    );
  }
}
